export const DATE_RE = /^\d{4}-\d{2}-\d{2}$/
export const DATETIME_RE = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}$/
export const MEDIA_URL_RE =
  /^(https:\/\/[^\s]+|\/[A-Za-z0-9._~:/?#[\]@!$&'()*+,;=%-]+)$/
export const HTTPS_URL_RE = /^https:\/\/[^\s]+$/
export const LOCALE_RE = /^[a-z]{2}(-[A-Z]{2})?$/
export const TIMEZONE_RE = /^[A-Za-z_]+\/[A-Za-z0-9_+\-]+$/
export const STORY_KEY_RE = /^[a-z0-9]+(?:-[a-z0-9]+)*$/

const DIGITS_TOKEN_RE = /^digits:(\d+)$/

export function parseDigitsWidth(token: string): number | null {
  const match = DIGITS_TOKEN_RE.exec(token)
  if (!match) return null
  const width = Number(match[1])
  if (!Number.isInteger(width) || width < 1) return null
  return width
}

export function digitsError(width: number, value: unknown): string | null {
  if (typeof value !== 'string') {
    return `expected ${width}-digit string, got ${typeof value}`
  }
  if (!new RegExp(`^\\d{${width}}$`).test(value)) {
    return `expected exactly ${width} decimal digits, got "${value}"`
  }
  return null
}

export type FormatToken =
  | 'date'
  | 'datetime'
  | 'media_url'
  | 'https_url'
  | 'locale'
  | 'timezone'
  | 'string'
  | 'number'
  | 'boolean'

export function formatError(
  token: FormatToken,
  value: unknown,
): string | null {
  if (value === null || value === undefined) {
    return `expected ${token}, got ${value}`
  }
  if (token === 'string') {
    return typeof value === 'string' ? null : `expected string, got ${typeof value}`
  }
  if (token === 'number') {
    return typeof value === 'number' && Number.isFinite(value)
      ? null
      : `expected number, got ${typeof value}`
  }
  if (token === 'boolean') {
    return typeof value === 'boolean'
      ? null
      : `expected boolean, got ${typeof value}`
  }
  if (typeof value !== 'string') {
    return `expected ${token} string, got ${typeof value}`
  }
  switch (token) {
    case 'date':
      return DATE_RE.test(value)
        ? null
        : `expected date YYYY-MM-DD, got "${value}"`
    case 'datetime':
      return DATETIME_RE.test(value)
        ? null
        : `expected datetime YYYY-MM-DDTHH:mm:ss, got "${value}"`
    case 'media_url':
      return MEDIA_URL_RE.test(value)
        ? null
        : `expected media_url (https://… or /…), got "${value}"`
    case 'https_url':
      return HTTPS_URL_RE.test(value)
        ? null
        : `expected https_url, got "${value}"`
    case 'locale':
      return LOCALE_RE.test(value)
        ? null
        : `expected locale (e.g. en, zh-CN), got "${value}"`
    case 'timezone':
      return TIMEZONE_RE.test(value)
        ? null
        : `expected IANA timezone, got "${value}"`
    default:
      return null
  }
}
